import { io } from 'socket.io-client'
import { store } from '../store/store'
import { updateStateFromWebSocket } from '../store/storeSlice'

class WebSocketService {
    constructor() {
        this.socket = null
        this.isConnected = false
        this.reconnectAttempts = 0
        this.maxReconnectAttempts = 5
        this.reconnectDelay = 1000
        this.lastPongReceived = null
        this.pingInterval = null
        this.pingIntervalMs = 30000 // 30 секунд
        this.pongTimeoutMs = 10000 // 10 секунд на ответ
        this.waitingForPong = false
        this.pongTimeout = null
        // Определяем базовый URL в зависимости от окружения
        // NODE_ENV автоматически устанавливается в 'development' при npm start и 'production' при npm run build
        if (process.env.NODE_ENV === 'development') {
            // this.baseURL = 'http://127.0.0.1:4500'
            this.baseURL = 'http://10.39.1.5:4500'
            // this.baseURL = "http://192.168.49.95:4500"
        } else {
            this.baseURL = 'https://map2.infosys05.ru'
        }
    }

    /**
     * Подключение к WebSocket серверу
     */
    connect() {
        if (this.socket && this.isConnected) {
            console.log('WebSocket уже подключен, пропускаем повторное подключение')
            return
        }

        // Если есть старое подключение, отключаем его
        if (this.socket) {
            console.log('Отключаем старое WebSocket подключение')
            this.socket.disconnect()
            this.socket = null
            this.isConnected = false
        }

        const token = localStorage.getItem('token')
        
        console.log('Создаем новое WebSocket подключение')
        this.socket = io(this.baseURL, {
            auth: {
                token: token
            },
            transports: ['websocket', 'polling'],
            timeout: 20000,
            forceNew: true
        })

        this.setupEventHandlers()
        
        console.log('WebSocket клиент инициализирован')
    }

    /**
     * Настройка обработчиков событий
     */
    setupEventHandlers() {
        this.socket.on('connect', () => {
            console.log('WebSocket подключен:', this.socket.id)
            this.isConnected = true
            this.reconnectAttempts = 0
            this.lastPongReceived = null
            this.waitingForPong = false
            this.startPingInterval()
        })

        this.socket.on('disconnect', (reason) => {
            console.log('WebSocket отключен:', reason)
            this.isConnected = false
            this.stopPingInterval()
            
            // Автоматическое переподключение
            if (reason === 'io server disconnect') {
                // Сервер принудительно отключил клиента
                this.handleReconnect()
            }
        })

        this.socket.on('connected', (data) => {
            console.log('Получено сообщение connected:', data)
        })

        this.socket.on('state_update', (data) => {
            console.log('Получено обновление состояния:', data)
            this.handleStateUpdate(data)
        })

        this.socket.on('response', (data) => {
            console.log('Получен ответ:', data)
        })

        this.socket.on('error', (error) => {
            console.error('WebSocket ошибка:', error)
        })

        this.socket.on('connect_error', (error) => {
            console.error('Ошибка подключения WebSocket:', error)
            this.handleReconnect()
        })

        // Обработка pong от сервера
        this.socket.on('pong', (data) => {
            this.lastPongReceived = new Date()
            if (this.waitingForPong && this.lastPingId === data?.pingId) {
                this.waitingForPong = false
                if (this.pongTimeout) {
                    clearTimeout(this.pongTimeout)
                    this.pongTimeout = null
                }
                console.log('Получен pong от сервера:', data?.pingId)
            }
        })
    }

    /**
     * Обработка обновления состояния
     */
    handleStateUpdate(data) {
        try {
            // Обновляем состояние в Redux store через специальное действие
            store.dispatch(updateStateFromWebSocket(data))
            console.log('Состояние обновлено в store через WebSocket')
        } catch (error) {
            console.error('Ошибка обновления состояния:', error)
        }
    }

    /**
     * Обработка переподключения
     */
    handleReconnect() {
        if (this.reconnectAttempts < this.maxReconnectAttempts) {
            this.reconnectAttempts++
            const delay = this.reconnectDelay * Math.pow(2, this.reconnectAttempts - 1)
            
            console.log(`Попытка переподключения ${this.reconnectAttempts}/${this.maxReconnectAttempts} через ${delay}ms`)
            
            setTimeout(() => {
                this.disconnect()
                this.connect()
            }, delay)
        } else {
            console.error('Превышено максимальное количество попыток переподключения')
        }
    }

    /**
     * Отключение от WebSocket сервера
     */
    disconnect() {
        this.stopPingInterval()
        if (this.pongTimeout) {
            clearTimeout(this.pongTimeout)
            this.pongTimeout = null
        }
        if (this.socket) {
            this.socket.disconnect()
            this.socket = null
            this.isConnected = false
            this.lastPongReceived = null
            this.waitingForPong = false
            console.log('WebSocket отключен')
        }
    }

    /**
     * Отправка сообщения на сервер
     */
    emit(event, data) {
        if (this.socket && this.isConnected) {
            this.socket.emit(event, data)
            console.log('Отправлено сообщение:', event, data)
        } else {
            console.warn('WebSocket не подключен, сообщение не отправлено:', event, data)
        }
    }

    /**
     * Подписка на событие
     */
    on(event, callback) {
        if (this.socket) {
            this.socket.on(event, callback)
        }
    }

    /**
     * Отписка от события
     */
    off(event, callback) {
        if (this.socket) {
            this.socket.off(event, callback)
        }
    }

    /**
     * Запуск интервала для отправки ping
     */
    startPingInterval() {
        if (this.pingInterval) {
            clearInterval(this.pingInterval)
        }

        this.pingInterval = setInterval(() => {
            this.sendPing()
        }, this.pingIntervalMs)

        console.log('Ping интервал запущен', { intervalMs: this.pingIntervalMs })
    }

    /**
     * Остановка интервала ping
     */
    stopPingInterval() {
        if (this.pingInterval) {
            clearInterval(this.pingInterval)
            this.pingInterval = null
            console.log('Ping интервал остановлен')
        }
    }

    /**
     * Отправка ping на сервер
     */
    sendPing() {
        if (!this.socket || !this.isConnected) {
            return
        }

        const pingId = Date.now().toString()
        const pingData = {
            pingId,
            timestamp: new Date().toISOString()
        }

        this.socket.emit('ping', pingData)
        this.waitingForPong = true
        this.lastPingId = pingId

        // Устанавливаем таймаут на ожидание pong
        if (this.pongTimeout) {
            clearTimeout(this.pongTimeout)
        }

        this.pongTimeout = setTimeout(() => {
            if (this.waitingForPong) {
                console.warn('Сервер не ответил на ping, переподключаемся')
                this.handleReconnect()
            }
        }, this.pongTimeoutMs)

        console.log('Отправлен ping на сервер:', pingId)
    }

    /**
     * Получение статуса подключения
     */
    getConnectionStatus() {
        return {
            isConnected: this.isConnected,
            socketId: this.socket?.id,
            reconnectAttempts: this.reconnectAttempts,
            lastPongReceived: this.lastPongReceived
        }
    }

    /**
     * Обновление токена авторизации
     */
    updateAuthToken(token) {
        if (this.socket) {
            this.socket.auth.token = token
            console.log('Токен авторизации обновлен')
        }
    }

    /**
     * Переподключение с новым токеном
     */
    reconnectWithNewToken(token) {
        this.disconnect()
        localStorage.setItem('token', token)
        this.connect()
    }
}

// Создаем единственный экземпляр сервиса
const webSocketService = new WebSocketService()

export default webSocketService
